import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import Attribute from ".//Attribute";
import "./personProfileStyle.css";
import { putPersonData, getLabels } from "api/AccountsApi";
import { Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { useHistory } from "react-router-dom";
import { getTag } from "api/AccountsApi";
import { toast } from "react-toastify";
import {
  getPersonById
} from "api/AccountsApi";
import {
  setPersonData
} from "ReduxStore/Slices/accountSlice";
import { useDispatch, useSelector } from "react-redux";
const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
});


const PersonProfile = (props) => {
  const [personData, setPersonData] = useState(null);
  const [allData, setallData] = useState([]);
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [change, setChange] = useState(false)
  const noShow = {
    id: true,
    crmExternalId: true,
    companyExternalId: true,
    asOfDate: true,
    emailCleaned: true,
    userId: true,
    companyId: true,
    _id: true,
    back: true,
    dataType: true,
    createdAt: true,
    updatedAt: true,
    isDeleted: true,

  };
  const history = useHistory();

  const customStyles = {
    control: base => ({
      ...base,
      padding: '10px',
      boxShadow: '0 8px 24px rgb(149 157 165 / 20%)'

    })

  }
  const [id, setId] = useState(0);

  const dispatch = useDispatch();


  useEffect(() => {
    let person = props.history ? props.history.location.state : props.data

    setPersonData(person);
    setId(person.id);


    getLabels()
      .then((data) => {

        var keyToLabels = {};

        data.forEach((obj) => {
          keyToLabels[obj.key] = obj.label;
        });

        if (person) {

          var allAttrs = Object.keys(person);
          var mapObj = [];

          console.log("keyToLabels", keyToLabels)
          keyToLabels['unSubscribe'] = 'unSubscribe'
          Object.keys(keyToLabels).forEach((key) => {
            let value = keyToLabels[key]
            console.log("keyssssssssss", key)
    
                if (
                  !noShow[key] &&
                  key != 'tags' &&
                  key != 'accounts' &&
                  key != 'tagList'
                ) {
    
                  var x = {
                    key: value,
                    value: person[key],
                  };
                  mapObj.push(x);
               }
    
              
            })



          setallData(mapObj)


          var allTags = [];
          if (typeof person.tags == "string") person.tags = person.tags.split("  ");

          person.tags &&
            person.tags.forEach((tag) => {
              if (tag) {
                var x = {
                  label: tag,
                  value: tag,
                };
                allTags.push(x);
              }
            });
          setTags(allTags);

          getTag()
            .then((data) => {
              let allTags = [];
              data.forEach((t) => {
                var x = {
                  label: t.tag,
                  value: t.tag,
                };
                allTags.push(x);
              });
              setTagList(allTags);
            })
            .catch((e) => { });

        }
      })
      .catch((e) => { });
  }, []);
  const handleChange = (newValue, actionMeta) => {
    setChange(true);
    console.group("Value Changed");


    console.groupEnd();
    setTags(newValue);
  };
  const handleCreate = (inputValue) => {
    setChange(true);
    setIsLoading(true);
    console.group("Option created");

    setTimeout(() => {
      const newOption = createOption(inputValue);

      console.groupEnd();
      setTags([...tags, newOption]);
      setIsLoading(false);
    }, 1000);
  };

  const updateAttribute = (value, label, _) => {
    setChange(true);

    var x = allData;
    var newL = [];
    x.forEach((y) => {
      if (y.key == label) {
        y.value = value;
      }
      newL.push(y);
    });
    setallData(newL);

  };
  const updatePerson = () => {
    var p = {};
    var t = [];
    var data = [];

    tags.forEach((tag) => {
      t.push(tag.label);
    });
    var emailMarketing = "inActive";
    allData.forEach((d) => {
      if (
        d.key != "createdAt" &&
        d.key != "updatedAt" &&
        d.key != "emailMarketing"
      )
        data.push({ key: d.key, value: d.value });
      else if (d.key == "emailMarketing") emailMarketing = d.value;
    });
    p.data = data;
    p.tags = t;
    if (
      emailMarketing == "inActive" ||
      emailMarketing.toLowerCase() == "unsubscribe"
    )
      p.subscriptionStatus = "unsubscribed";
    else p.subscriptionStatus = "subscribed";

    putPersonData(id, p)
      .then(function (data) {
        props.refetchPerson();

        toast.success("Account has been updated successfully. ");
      })
      .catch(function (error) {


        if (error.response) {



          toast.error(error.response.data.message || "Error");
        }
      });
  };

  async function updateGlobalPersonData(id) {
    getTag()
      .then((tags) => {

        getPersonById(id).then((person) => {
          person.tags = tags

          dispatch(setPersonData(person))

        })


      })
      .catch((e) => { });
  }

  return (
    <>


      <div id="p-container">

        <h2 className="p-title mt-5">Person Details</h2>

        {personData && allData ? (
          <div style={{ paddingLeft: "30px" }}>

            <div className='pd-main'>
              {allData.map((obj) => {

                if(obj.key == 'isProspect' || obj.key =='unSubscribe')
                  return  <div style={{ width: "100%", display: 'flex' }}>
                  <span style={{ flex: 0.7 }} className="attributeLabel">{obj.key}</span>
        
                  <div style={{ flex: 1, display: 'flex' }}>
                    <span
                      className="attributeLabel"
                      style={{ marginRight: "9px", marginLeft: "3%" }}
                    >
                      :
                    </span>
                    <span className="ml-2"></span>
                    <select className="valueW attributeValue "  onChange={(e) => updateAttribute(e.target.value, obj.key)} value={obj.value}>
                          <option value={true}>True</option>
                          <option value={false}>False</option>
                        </select>
        
                  </div>
                </div>
                  

                else 
                  return (
                    <Attribute
                      label={obj.key}
                      value={obj.value}
                      fun={updateAttribute}
                    ></Attribute>
                  );
              })}
            </div>
            <h6 className="p-groupTitle">Tags</h6>
            <div style={{ width: "70%", marginLeft: "4.5%" }}>
              <CreatableSelect
                isMulti={true}
                isClearable
                value={tags}
                placeholder={"Add.."}
                onChange={handleChange}
                onCreateOption={handleCreate}
                isDisabled={isLoading}
                isLoading={isLoading}
                options={tagList}
                styles={customStyles}

              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="pd-foot">
          <input
            type="submit"
            name="Save"
            style={{ cursor: "pointer" }}
            className="lg_btn secondary mb-2"
            id="profileSave"
            value="SAVE"
            onClick={() => updatePerson()}
          />

          <input
            type="submit"
            name="Save"
            style={{ cursor: "pointer" }}
            className="lg_btn secondary mb-2"
            id="profileCancel"
            value="Cancel"
            onClick={() => { history.goBack() }
            }
          />
        </div>

      </div>
    </>
  );
};

export default PersonProfile;